import { createAction } from 'redux-actions'

export const types = {
    ASSIGN_CHALLENGE_SETTINGS: 'viewchllenge/ASSIGN_CHALLENGE_SETTINGS',
    GET_CHALLENGE_DETAILS : 'viewchllenge/GET_CHALLENGE_DETAILS',
    POPULATE_AMBASSADOR_PROFILE:'viewchllenge/POPULATE_AMBASSADOR_PROFILE'
}

export const actions = {
    assignChallengeSettings: createAction<ChallengeSettingsDto>(types.ASSIGN_CHALLENGE_SETTINGS),
    getChallengeSettings :  createAction<ViewChallengeDataRecord>(types.GET_CHALLENGE_DETAILS),
    populateAmbassadorProfile : createAction<ViewAmbassadorProfileRecord>(types.POPULATE_AMBASSADOR_PROFILE)
}
